import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiList } = FiIcons;

export default function TableOfContents({ headings }) {
  return (
    <div className="flex flex-col h-full bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="bg-slate-50 border-b border-slate-200 px-4 py-2.5 shrink-0">
        <h2 className="text-xs font-black text-slate-600 uppercase tracking-widest flex items-center">
          <SafeIcon icon={FiList} className="mr-2 text-indigo-500" />
          Contents
        </h2>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto p-3">
        <ol className="space-y-1">
          {headings.map((h, i) => (
            <li
              key={i}
              className="flex items-start gap-2 group"
              style={{ paddingLeft: `${(h.level - 1) * 12}px` }}
            >
              <span className="text-[10px] font-black text-indigo-300 mt-0.5 shrink-0 w-5 text-right">
                {i + 1}.
              </span>
              <span className={`text-xs leading-snug text-slate-600 group-hover:text-indigo-600 transition-colors cursor-default ${h.level === 1 ? 'font-bold' : h.level === 2 ? 'font-semibold' : 'font-medium text-slate-500'}`}>
                {h.text}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}